// src/pages/RecruitmentAnalytics/components/SourceEffectiveness.tsx
import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

interface SourceData {
  source: string;
  hires: number;
}

interface Props {
  data: SourceData[];
  colors: string[];
}

const SourceEffectiveness: React.FC<Props> = ({ data, colors }) => {
  return (
    <div style={{ width: '100%', height: 250 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="hires"
            nameKey="source"
            cx="50%"
            cy="50%"
            outerRadius={80}
            label={(entry) => `${entry.source}: ${entry.hires}`}
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SourceEffectiveness;